import { createSelector } from '@ngrx/store';
import { surveyFeature } from '../reducers/survey.reducer';

// Auto-generated selectors from createFeature — one per top-level state key.
export const {
  selectLoading,
  selectError,
  selectSurveyState,
  selectSurveys,
  selectFilters,
  selectSort,
  selectPagination,
  selectContext,
} = surveyFeature;

export const selectPage = createSelector(selectPagination, (p) => p.page);
export const selectHasMore = createSelector(selectPagination, (p) => p.hasMore);

export const selectSurveyRequest = createSelector(selectSurveyState, (s) => ({
  // All filter fields — new ones propagate automatically
  ...s.filters,

  // Pagination
  page: s.pagination.page,
  limit: s.pagination.limit,

  // Sort — sent as optional params; API ignores unsupported fields gracefully
  sortField: s.sort?.sortBy,
  sortDirection: s.sort?.sortOrder,

  // Request context
  targeting: s.context?.targeting ?? 0,
  isServiceBuyerRequest: !!s.context?.isServiceBuyerRequest,
  isMultiBuyerRequest: !!s.context?.isMultiBuyerRequest,
  mobile: !!s.context?.mobile,
}));
